module.exports = __webpack_public_path__ + "static/media/image-1200.48ab8a72.webp";